import { styled } from "@mui/material"
import MuiCheckbox from "@mui/material/Checkbox"

export const Checkbox = styled(MuiCheckbox)(({ theme }) => ({
    color: theme.palette["border/border-primary"].main,
    "&.Mui-checked": {
        color: theme.palette["border/border-primary"].main,
    },
}))